(function () {
  var PAGE_SIZE = 10;
  var ANONYMOUS_LABEL = "Anonymous donor";

  function i18n() {
    if (window.__mayekooFundraiserI18n) return window.__mayekooFundraiserI18n;
    var script = document.getElementById("mayekoo-fundraiser-i18n");
    var payload = {};
    if (script) {
      try { payload = JSON.parse(script.textContent || "{}"); } catch (err) { payload = {}; }
    }
    window.__mayekooFundraiserI18n = payload;
    return payload;
  }

  function t(key, fallback) {
    var value = i18n()[key];
    return value == null || value === "" ? fallback : value;
  }

  function interpolate(template, vars) {
    return String(template || "").replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      return vars[name] == null ? "" : String(vars[name]);
    });
  }

  function shopifyRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
  }

  function formatAmount(decimalStr) {
    var parsed = Number.parseFloat(String(decimalStr || "0"));
    if (!Number.isFinite(parsed)) return "";
    var cents = Math.round(parsed * 100);
    if (typeof window.Shopify !== "undefined" && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents);
    }
    return "$" + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function amountLabel(donor) {
    var amount = formatAmount(donor.totalAmount);
    if ((Number(donor.giftCount) || 0) > 1) {
      return amount + " total · " + donor.giftCount + " gifts";
    }
    return amount;
  }

  function resolveHeartIconSrc(root) {
    var existing = root.querySelector(".mayekoo-fundraiser__donor-icon img");
    if (existing && existing.getAttribute("src")) return existing.getAttribute("src");
    var themed = document.querySelector('link[data-mayekoo-donor-heart-icon][href]');
    if (themed) return themed.getAttribute("href");
    return "";
  }

  function buildEntry(donor, iconSrc) {
    var li = document.createElement("li");
    li.className = "mayekoo-fundraiser__donor-item";
    li.tabIndex = -1;
    var iconWrap = document.createElement("span");
    iconWrap.className = "mayekoo-fundraiser__donor-icon";
    iconWrap.setAttribute("aria-hidden", "true");
    if (iconSrc) {
      var img = document.createElement("img");
      img.src = iconSrc;
      img.alt = "";
      img.width = 47;
      img.height = 47;
      img.loading = "lazy";
      iconWrap.appendChild(img);
    }
    var details = document.createElement("div");
    details.className = "mayekoo-fundraiser__donor-details";
    var amount = document.createElement("span");
    amount.className = "mayekoo-fundraiser__donor-amount";
    amount.textContent = amountLabel(donor);
    var separator = document.createElement("span");
    separator.className = "mayekoo-fundraiser__donor-separator";
    separator.setAttribute("aria-hidden", "true");
    separator.innerHTML = "&bull;";
    var name = document.createElement("span");
    name.className = "mayekoo-fundraiser__donor-name";
    name.textContent = donor.name || t("anonymous_donor", ANONYMOUS_LABEL);
    details.appendChild(amount);
    details.appendChild(separator);
    details.appendChild(name);
    li.appendChild(iconWrap);
    li.appendChild(details);
    return li;
  }

  function replaceList(listEl, donors, iconSrc) {
    if (!listEl) return;
    listEl.replaceChildren();
    donors.forEach(function (donor) {
      listEl.appendChild(buildEntry(donor, iconSrc));
    });
  }

  function hideLegacyExpandUi(root) {
    root.querySelectorAll("[data-donor-expand], [data-donor-expanded]").forEach(function (el) {
      el.hidden = true;
      el.setAttribute("aria-hidden", "true");
    });
  }

  function fetchJson(path) {
    return fetch(shopifyRoot() + path, { credentials: "same-origin", headers: { Accept: "application/json" } }).then(
      function (response) {
        if (!response.ok) throw new Error("donor_wall_http");
        return response.json();
      },
    );
  }

  function donorWallUrl(handle, extra) {
    var params = new URLSearchParams(extra || {});
    params.set("handle", handle);
    return "apps/mayekoo-fundraising/donor-wall?" + params.toString();
  }

  function applySummary(root, summary) {
    var donorCount = Number(summary.donorCount) || 0;
    var giftCount = Number(summary.giftCount) || 0;
    var tab = root.querySelector('[data-mayekoo-tab="donors"], [data-tab="donors"]');
    if (tab) tab.textContent = donorCount === 1 ? "Donor (1)" : "Donors (" + donorCount + ")";
    var proof = root.querySelector(".mayekoo-fundraiser__donor-social-proof");
    if (proof) {
      proof.replaceChildren();
      var donorMetric = document.createElement("span");
      donorMetric.className = "mayekoo-fundraiser__donor-metric";
      donorMetric.textContent = donorCount === 1 ? "1 donor" : donorCount + " donors";
      var giftMetric = document.createElement("span");
      giftMetric.className = "mayekoo-fundraiser__gift-metric";
      giftMetric.textContent = giftCount === 1 ? "1 gift" : giftCount + " gifts";
      proof.appendChild(donorMetric);
      proof.appendChild(giftMetric);
      proof.hidden = donorCount <= 0 && giftCount <= 0;
    }
    var iconSrc = resolveHeartIconSrc(root);
    var newest = root.querySelector(".mayekoo-fundraiser__donor-column:first-child .mayekoo-fundraiser__donor-list");
    var top = root.querySelector(".mayekoo-fundraiser__donor-column:last-child .mayekoo-fundraiser__donor-list");
    if (newest) replaceList(newest, summary.newest || [], iconSrc);
    if (top && top !== newest) replaceList(top, summary.top || [], iconSrc);
  }

  function ensureAllDonors(root, summary) {
    var donorsPanel = root.querySelector('[data-mayekoo-tabpanel="donors"], [data-tabpanel="donors"]');
    var donorFull = donorsPanel && donorsPanel.querySelector(".mayekoo-fundraiser__donor-full");
    if (!donorFull) return null;
    hideLegacyExpandUi(donorFull);
    var existing = donorFull.querySelector("[data-mayekoo-donor-chronological]");
    if (existing) return existing;
    var section = document.createElement("div");
    section.className = "mayekoo-fundraiser__donor-chronological";
    section.setAttribute("data-mayekoo-donor-chronological", "");
    var heading = document.createElement("h3");
    heading.className = "mayekoo-fundraiser__donor-section-title";
    heading.textContent = t("all_donors", "All donors");
    section.appendChild(heading);
    var status = document.createElement("p");
    status.className = "mayekoo-fundraiser__donor-load-status";
    status.setAttribute("data-donor-load-status", "");
    status.setAttribute("aria-live", "polite");
    section.appendChild(status);
    var list = document.createElement("ul");
    list.className = "mayekoo-fundraiser__donor-list mayekoo-fundraiser__donor-list--chronological";
    list.setAttribute("data-donor-chronological-list", "");
    list.setAttribute("role", "list");
    section.appendChild(list);
    var button = document.createElement("button");
    button.type = "button";
    button.className = "mayekoo-fundraiser__donor-load-more";
    button.setAttribute("data-donor-load-more", "");
    button.textContent = t("load_more", "Load 10 more");
    section.appendChild(button);
    donorFull.appendChild(section);
    return section;
  }

  function readAvailableDonorEntries(root) {
    var productId = root.getAttribute("data-campaign-product-id");
    var script = document.getElementById("mayekoo-donor-wall-data-" + productId)
      || document.querySelector("[data-mayekoo-donor-wall-data]");
    if (!script) return [];
    try {
      var payload = JSON.parse(script.textContent || "{}");
      var rows = Array.isArray(payload.availableDonorEntries) ? payload.availableDonorEntries : [];
      return rows.filter(function (row) {
        if (!row || typeof row !== "object") return false;
        var name = String(row.name || "").trim();
        return row.amount != null || name.length > 0;
      }).slice().reverse().map(function (row) {
        return {
          name: String(row.name || "").trim(),
          totalAmount: String(row.amount == null ? "" : row.amount),
          giftCount: Number(row.giftCount) || 1,
        };
      });
    } catch (err) {
      return [];
    }
  }

  function initAllDonors(root, handle, summary) {
    var section = ensureAllDonors(root, summary);
    if (!section || section.dataset.mayekooDonorBound === "1") return;
    section.dataset.mayekooDonorBound = "1";
    var listEl = section.querySelector("[data-donor-chronological-list]");
    var statusEl = section.querySelector("[data-donor-load-status]");
    var loadBtn = section.querySelector("[data-donor-load-more]");
    var iconSrc = resolveHeartIconSrc(root);
    var available = readAvailableDonorEntries(root);
    var shown = 0;

    function setStatus(total) {
      var template = total === 1
        ? t("showing_entry", "Showing {{ shown }} of {{ total }} available donor entry")
        : t("showing_entries", "Showing {{ shown }} of {{ total }} available donor entries");
      statusEl.textContent = interpolate(template, { shown: shown, total: total });
      var more = shown < total;
      loadBtn.hidden = !more;
      loadBtn.disabled = !more;
      if (!more) loadBtn.setAttribute("aria-hidden", "true");
      else loadBtn.removeAttribute("aria-hidden");
    }

    function appendSlice(entries) {
      var next = entries.slice(shown, shown + PAGE_SIZE);
      var firstNew = null;
      next.forEach(function (donor) {
        var item = buildEntry(donor, iconSrc);
        if (!firstNew) firstNew = item;
        listEl.appendChild(item);
      });
      shown += next.length;
      setStatus(entries.length);
      return firstNew;
    }

    loadBtn.addEventListener("click", function () {
      var firstNew = appendSlice(available);
      if (loadBtn.hidden) {
        if (firstNew) firstNew.focus();
        return;
      }
      loadBtn.focus();
    });
    appendSlice(available);
  }

  function initWidget(root) {
    if (root.dataset.mayekooDonorWallBound === "1") return;
    var handle = root.getAttribute("data-campaign-handle");
    if (!handle) return;
    root.dataset.mayekooDonorWallBound = "1";
    hideLegacyExpandUi(root);
    fetchJson(donorWallUrl(handle, { mode: "summary" }))
      .then(function (summary) {
        if (!summary || summary.ok !== true) return;
        applySummary(root, summary);
        initAllDonors(root, handle, summary);
      })
      .catch(function () {});
  }

  function initAll() {
    document.querySelectorAll("[data-mayekoo-fundraiser]").forEach(initWidget);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", initAll);
  window.addEventListener("load", initAll);
})();
